/**
 * Join Stories Add to Cart Integration
 * Docs: https://docs.join-stories.com/docs/add-to-cart-javascript
 */

const joinStoriesAddToCart = async ({ productId, price, variantId }) => {
  const formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
        const errorData = await response.json();
        // Check for specific error codes if needed, e.g. stock issues
        if (errorData.status === 422) {
             throw 'MY_ERROR_PRODUCT_OUT_OF_STOCK';
        }
        throw new Error('Failed to add to cart');
    }

    // Fetch updated cart WITH the cart-drawer section to allow the theme to re-render it
    const sectionsToRender = ['cart-drawer']; // Add other sections if needed (e.g. cart-icon-bubble)
    const cartResponse = await fetch(window.Shopify.routes.root + `cart.js?sections=${sectionsToRender.join(',')}`);
    const cart = await cartResponse.json();

    // Dispatch event to update theme UI
    // 'baseEvent': 'variant:add' tells the CartDrawer (lines 8767 in theme.js) to open itself
    document.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { 
            cart: cart,
            baseEvent: 'variant:add'
        }
    }));
    
    // Also dispatch cart:refresh to be safe as some components might listen to it
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));

    
    return cart;

  } catch (error) {
    throw error;
  }
};

document.addEventListener('JOIN_STORIES_ADD_TO_CART', async (event) => {
  try {
    const { widgetAlias, orderId, productId, price, variantId } = event.detail;
    
    await joinStoriesAddToCart({ productId, price, variantId });
    
    if (window.JoinStories) {
        window.JoinStories.resolveAddToCart(orderId);
    }
  } catch (error) {
    // ... error handling
    console.error('Join Stories Add to Cart Error:', error);
    if (window.JoinStories) {
        switch (error) {
          case 'MY_ERROR_PRODUCT_OUT_OF_STOCK':
            window.JoinStories.resolveAddToCart(orderId, 'PRODUCT_OUT_OF_STOCK');
            break;
          default:
            window.JoinStories.resolveAddToCart(orderId, true);
        }
    }
  }
});

document.addEventListener('JOIN_STORIES_SEE_CART', function (event) {
  if (window.JoinStories) {
    window.JoinStories.closePlayer();
  }

  // Use the theme's drawer opening mechanism if available, otherwise redirect to cart
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.show === 'function') {
    cartDrawer.show();
  } else {
    window.location.href = window.Shopify.routes.root + 'cart';
  }
});
